import React from 'react'

import './index.scss'

type Props = {
  onExpand: () => void
  answer: boolean
  expanded: boolean
}

export function Expandor({ answer, expanded, onExpand }: Props) {
  return (
    <div onClick={onExpand} className='modern-chat-expandor__wrapper'>
      {!expanded && (
        <div
          className={`modern-chat-expandor__gradient ${
            answer ? 'modern-chat-expandor__gradient--answer' : ''
          }`}
        />
      )}
      <div
        className={`modern-chat-expandor__arrow ${
          expanded ? 'modern-chat-expandor__arrow--expanded' : ''
        }`}
      />
    </div>
  )
}
